module.exports = __webpack_public_path__ + "img/复制3.b1c85604.svg";